import React, { useContext, useEffect, useState } from 'react'
import Search from '../Components/Images/search-lg.svg'
import Orange from '../Components/Images/orange.png'
import Red from '../Components/Images/red.png'
import Green from '../Components/Images/green.png'
import { IoArrowDownSharp } from 'react-icons/io5'
import menus from '../Components/Images/menu.png';
import { Context } from '../Context/Context'

const CreatedInvoices = ({ UserInvoice }) => {

    const { handleViewInvoice, handleDeleteInvoice, setSelectedInvoice } = useContext(Context)
    const [menu, setMenu] = useState(null)
    const [searchQuery, setSearchQuery] = useState('');
    const [isSmScreen, setIsSmScreen] = useState(window.innerWidth < 450);

    useEffect(() => {
        const handleResize = () => {
            setIsSmScreen(window.innerWidth < 450);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleInvoiceClick = (id) => {
        localStorage.setItem('invoiceID', id);
    };

    const handleSearch = (query) => {
        setSearchQuery(query);  // Update the search query state
    };

    const filteredInvoices = searchQuery
        ? UserInvoice.filter(invoice => {
            const formattedDate = new Date(invoice.date_created).toLocaleDateString("en-GB", {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            }).toLowerCase();

            const query = searchQuery.toLowerCase();

            return (
                formattedDate.includes(query) ||
                (invoice.payer_name?.toLowerCase() || '').includes(query) ||
                (invoice.status?.toString().toLowerCase() || '').includes(query) ||
                (invoice.due_date?.toLowerCase() || '').includes(query)
            );
        })
        : UserInvoice;


    return (
        <div className='lg:p-10 lg:py-5 py-5 px-4'>
            <div className='relative'>
                <input
                    type="text"
                    placeholder="Search invoices by number, items, clients or amount"
                    value={searchQuery}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="px-4 py-2 border-none outline-none border-gray-300 w-full placeholder:text-[14px] placeholder:text-[#78757A] ml-5 rounded-md"
                />
                <img src={Search} alt="" className='absolute top-2' />
            </div>
            <div className='sm:grid md:grid-cols-5 sm:grid-cols-4 flex justify-between gap-5 border-t-[1.3px] border-b-[1.3px] px-3 text-[#78757A] border-[#F3F0F7] mt-3 py-[14px] text-[14px] font-medium text-left'>
                <div className='flex gap-5 items-center min-w-0'>
                    <input className='mt-1 size-4' type="checkbox" />
                    <div className='flex items-center gap-1'>
                        <p>Invoice date</p>
                    </div>
                </div>
                <div className='flex items-center min-w-0'>
                    <p className='truncate'>Payer name</p>
                </div>
                <div className='sm:flex hidden gap-1 items-center justify-end min-w-0'>
                    <p className='truncate'>Amount</p>
                    <IoArrowDownSharp className='text-[16px]' />
                </div>
                <div className='md:flex hidden gap-1 items-center min-w-0'>
                    <p className='truncate'>Status</p>
                    <IoArrowDownSharp className='text-[16px]' />
                </div>
                <div className='min-w-0 sp:flex hidden items-center gap-5'>
                    <div className='flex gap-1 items-center min-w-0'>
                        <p className='truncate'>Due date</p>
                        <IoArrowDownSharp className='text-[16px]' />
                    </div>
                    <div className='cursor-pointer mt-[-10px] invisible'>
                        <p className='font-semibold text-[18px] text-black/60'>...</p>
                    </div>
                </div>
            </div>
            {filteredInvoices.map((invoice, i) => {
                return <div
                    key={i}
                    onClick={isSmScreen ? () => {
                        handleViewInvoice(i)
                        setSelectedInvoice(invoice)
                        handleInvoiceClick(invoice.id)
                        setMenu(menu === i ? null : i)
                    }
                        : undefined
                    }
                    className='sm:grid md:grid-cols-5 sm:grid-cols-4 flex justify-between gap-5 hover:bg-[#F3F0F7] cursor-pointer border-b-[1.3px] text-[#525154] border-[#F3F0F7] py-[14px] px-3 text-[14px] font-medium text-left'
                >
                    <div className='flex gap-5 items-center min-w-0'>
                        <input className='mt-1 size-4 cursor-pointer' type="checkbox" />
                        <p className='truncate'>
                            {new Date(invoice.date_created).toLocaleDateString("en-GB", {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                            })}
                        </p>
                    </div>

                    <div className='min-w-0'>
                        <p className='truncate'>{invoice.payer_name}</p>
                    </div>
                    <div className='min-w-0 sm:flex hidden items-center justify-end'>
                        ${invoice.breakdown.reduce((sum, item) => sum + (item.unit_price * item.quantity), 0).toFixed(2)}
                    </div>
                    <div className='min-w-0 md:flex hidden'>
                        <p className={`flex items-center gap-1 ${invoice.status === 'pending' ? 'text-[#F59E0B]' : invoice.status === 'paid' ? 'text-[#1CB353]' : 'text-[#EF4444]'}`}>
                            <img src={invoice.status === 'pending' ? Orange : invoice.status === 'paid' ? Green : Red} alt="" />
                            {invoice.status}
                        </p>
                    </div>
                    <div className='min-w-0 sp:flex hidden items-center justify-between gap-5 relative'>
                        <p>
                            {new Date(invoice.due_date).toLocaleDateString("en-GB", {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                            })}
                        </p>
                        <div
                            onClick={() => setMenu(menu === i ? null : i)}
                            className={`font-semibold text-[18px] text-black/60 ${menu === i ? 'bg-[#E6E4EB] rounded-md p-2 py-3' : 'py-2'}`}
                        >
                            <img src={menus} alt="" />
                        </div>
                        {menu === i && (
                            <div className='bg-white z-10 flex flex-col py-2 right-[-2px] absolute top-[37px] shadow-md rounded-md'>
                                <p
                                    onClick={() => {
                                        setSelectedInvoice(invoice)
                                        handleViewInvoice()
                                        handleInvoiceClick(invoice.id)
                                        setMenu(menu === i ? null : i)
                                    }}
                                    className='cursor-pointer hover:bg-[#F9F7FC] px-2 py-1'
                                >
                                    View invoice
                                </p>
                                <p
                                    onClick={() => {
                                        handleDeleteInvoice()
                                        handleInvoiceClick(invoice.id)
                                        setMenu(menu === i ? null : i)
                                    }}
                                    className='cursor-pointer hover:bg-[#F9F7FC] px-2 py-1'
                                >
                                    Delete invoice
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            })}
            <p className='text-[#78757A] mt-4'>
                {filteredInvoices?.length} {filteredInvoices?.length > 1 ? 'Payers' : 'Payer'}
            </p>
        </div>
    )
}

export default CreatedInvoices